import { AvailableCountries, AvailableLanguages } from 'types/users.types';

/** Same URLs as signup footer (`Footer.component.tsx`); single source of truth for marketing terms pages. */
const TERMS_URL_BY_COUNTRY: Record<
  AvailableCountries,
  Partial<Record<AvailableLanguages, string>>
> = {
  [AvailableCountries.germany]: {
    [AvailableLanguages.en]: 'https://www.accountable.de/en/terms/',
    [AvailableLanguages.de]: 'https://www.accountable.de/agb/',
    [AvailableLanguages.fr]: '',
    [AvailableLanguages.nl]: '',
  },
  [AvailableCountries.belgium]: {
    [AvailableLanguages.en]: 'https://www.accountable.eu/en-be/terms',
    [AvailableLanguages.de]: '',
    [AvailableLanguages.nl]:
      'https://www.accountable.eu/nl-be/algemene-voorwaarden-accountable-app-en-services/',
    [AvailableLanguages.fr]:
      'https://www.accountable.eu/fr-be/conditions-generales-de-vente-accountable-app-et-services/',
  },
};

const DEFAULT_FALLBACK = 'https://www.accountable.eu/en-be/terms';

export function getAccountableTermsUrl(
  country: AvailableCountries | undefined,
  language: string,
): string {
  const c = country ?? AvailableCountries.germany;
  const lang = language as AvailableLanguages;
  const row = TERMS_URL_BY_COUNTRY[c];
  const direct = row[lang];
  if (direct) return direct;

  if (row.en) return row.en;
  if (row.de) return row.de;
  if (row.nl) return row.nl;
  if (row.fr) return row.fr;

  return DEFAULT_FALLBACK;
}
